(function () {
    'use strict';

    angular.module("imApp").factory("webpageTableEditService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 22,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 23,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
